import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-copilot',
  templateUrl: './copilot.component.html',
  styleUrls: ['./copilot.component.scss'],
  standalone: false
})
export class CopilotComponent {
  @Output() iscloseModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() expandToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() triggerElement?: ElementRef;
  @Input() isExpanded: boolean = false;
  @ViewChild('copilotPanel') copilotElement!: ElementRef;

  panelClosingStyle: boolean = false;
  userMessage: string = '';
  isLoading: boolean = false;

  recommendedPrompts = [
    { prompt: 'What is my total revenue, number of orders, and average order value for any selected period?' },
    {
      prompt: 'Which products and categories drive the most revenue and profit, not just sales volume?'
    },
    {
      prompt: 'Which products have high return or cancellation rates and why (reason codes, segments, campaigns)?'
    },
    {
      prompt: 'Who are my most valuable customers by lifetime value, margin, and repeat purchase behavior?'
    },
    {
      prompt: 'Which Offers has given me the highest Sales in the last 6 months ?'
    },
    {
      prompt: 'Which days, times, and geographies generate the highest orders and revenue in the last Month?'
    }
  ];

  messages: Array<{ type: 'user' | 'assistant'; content: string }> = [];

  selectPrompt(prompt: any) {
    this.userMessage = prompt.prompt;
    this.sendMessage();
  }

  sendMessage() {
    if (!this.userMessage.trim()) return;

    // Add user message
    this.messages.push({
      type: 'user',
      content: this.userMessage
    });

    const userQuery = this.userMessage;
    this.userMessage = '';
    this.isLoading = true;

    // Simulate AI response (replace with actual API call)
    setTimeout(() => {
      this.messages.push({
        type: 'assistant',
        content: `I received your request: "${userQuery}". This is a simulated response. Connect to your AI backend to get real responses.`
      });
      this.isLoading = false;
    }, 1000);
  }

  closePanel() {
    this.panelClosingStyle = true;
    setTimeout(() => {
      this.iscloseModal.emit(false);
    }, 300);
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  clearChat() {
    this.messages = [];
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
    this.expandToggle.emit(this.isExpanded);
  }
}
